module.exports = __webpack_public_path__ + "img/success_rabbit.2c8955b1.png";